module.exports = __webpack_public_path__ + "img/librate-logo.da6c406a.png";